import StoreTableMixin from './StoreTableMixin';

export default {
  mixins: [StoreTableMixin],
  computed: {
    mixSearchQuery: {
      get() {
        return this.search;
      },
      set(value) {
        this.setSearch(value);
      },
    },

    queriedData() {
      if (this.sort !== null && this.sort.charAt(0) === '-') {
        this.tableData.reverse();
      }
      return this.tableData;
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.meta.total < highBound) {
        highBound = this.meta.total;
      }
      return highBound;
    },

    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
  },
  data() {
    return {
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      defaultSort: null,
      sort: null,
      meta: {},
    };
  },

  methods: {
    setMeta(data) {
      this.meta = data;
      this.pagination.total = data.total;
    },

    changePage(value) {
      if (this.pagination.total > 0) {
        this.setPage(value);
        this.pagination.currentPage = value;
        this.fetchTableData();
      }
    },

    sortChange({ prop, order }) {
      if (order === 'ascending') {
        this.sort = prop;
      } else if (order === 'descending') {
        this.sort = `-${prop}`;
      } else {
        this.sort = null;
      }
      this.fetchTableData();
    },
  },

  watch: {
    'pagination.perPage': function (value) {
      this.setPerPage(value);
    },

    mixSearchQuery() {
      const savedQuery = this.mixSearchQuery;

      setTimeout(() => {
        if (this.mixSearchQuery === savedQuery) {
          this.setPage(1);
          this.fetchTableData();
        }
      }, 1000);
    },
  },
};
